export default "__VITE_ASSET__b4c6d8ed__"